import React from 'react';
import * as yup from "yup";
import {
    CostSupplier,
    CostSupplierQueryQuery, CurrenciesQueryQuery, Currency,
    useCostSupplierQueryQuery, useCostSuppliersMutationMutation, useCurrenciesQueryQuery, useUpdateCurrenciesMutation
} from '../../generated/graphql';

import {ListEditor} from '../../components/list-editor';
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const schema =  yup.array().of(
    yup.object().shape({
        'label': yup.string().required(),
        'glyph':yup.string().required(),
    }));

function blankCurrency(): Currency {
    return {
        id: uniqueId(),
        label: '',
        glyph:''
    };
}

const columns = [{
    header: 'Name',
    accessor: 'label',
    dataType:'text'
}, {
    header: 'Glyph',
    accessor: 'glyph',
    dataType:'text',
    width:'narrow'
}
];

function getValues(data:CurrenciesQueryQuery) {
    return data?.currencies;
}

const Currencies = () => {
    const url = useLocation().pathname;
    const query = useCurrenciesQueryQuery();
    const [mutation,mutationResult] = useUpdateCurrenciesMutation();
    return (
        <ListEditor
            className="currencies"
            columns={columns}
            validationSchema={schema}
            title="Currencies"
            permission="currencies"
            mutation={mutation}
            saveResult={mutationResult}
            query={query}
            newRow={blankCurrency}
            newRowLabel="Add Currency"
            baseUrl={url}
            getValues={getValues}
        />);
}
export default Currencies;